var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { arcgisImport } from '../../ArcgisMapCdn';
import defaultSymbol from '../../assets/defaultSymbol.svg';
import { formatCoordinatesToString } from './formatCoordinates';
export const defaultCoordinates = '-118.80500,34.02700';
export const markerSymbol = (url, width = 36, height = 47) => {
    return {
        url: url !== null && url !== void 0 ? url : defaultSymbol,
        type: 'picture-marker',
        width: width,
        height: height,
        yoffset: height / 2,
    };
};
export const createPoint = (point, markerSymbol) => __awaiter(void 0, void 0, void 0, function* () {
    const Graphic = yield arcgisImport('esri/Graphic');
    return new Graphic({
        geometry: point,
        symbol: markerSymbol,
    });
});
export const addLocationButton = (view, handleValueChange) => __awaiter(void 0, void 0, void 0, function* () {
    const Track = yield arcgisImport('esri/widgets/Track');
    const track = new Track({
        view: view,
        graphic: undefined,
        useHeadingEnabled: false,
    });
    track.on('track', (evt) => {
        const { longitude, latitude } = evt.position.coords;
        handleValueChange(formatCoordinatesToString(latitude, longitude));
    });
    view.ui.add(track, 'top-left');
});
